import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CreateOrderModalData } from 'app/core/store/calendar/orders/calendar-orders.interface';
import { util } from 'app/core/util/util';
import moment from 'moment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Order } from 'app/core/interfaces/order.interface';
import { OrdersCalendarSandbox } from 'app/core/sandboxes/orders-calendar.sandbox';
import { FlordersFilter } from 'app/core/interfaces/florders-filter.interface';

@Component({
  selector: 'app-calendar-create-order-modal',
  templateUrl: './calendar-create-order-modal.component.html',
  styleUrls: ['./calendar-create-order-modal.component.scss'],
})
export class CalendarCreateOrderModalComponent implements OnInit {
  title: string = '';
  isLoading = false;
  orders: Order[] = [];

  constructor(
    private dialogRef: MatDialogRef<CalendarCreateOrderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateOrderModalData,
    private sandbox: OrdersCalendarSandbox,
    private cd: ChangeDetectorRef
  ) {
    if (data.day.florderInfos.length) {
      this.loadData(data);
    }
  }

  ngOnInit() {
    // ex: 4th June 2020
    this.title = moment(this.data.day.date).format('Do MMMM YYYY');
  }

  close(createOrder: boolean, id?: string | number, salesOrderNumber?: string) {
    const date = util.formatDate(this.data.day.date.toDate());
    this.dialogRef.close({ createOrder, id, salesOrderNumber, date });
  }

  private async loadData(data: CreateOrderModalData) {
    this.isLoading = true;
    const dayFilter: FlordersFilter = {
      ...data.filter,
      unloadingDateFrom: data.day.dateString,
      unloadingDateTo: data.day.dateString,
    };

    this.orders = await this.sandbox.loadOrders$$(dayFilter);
    this.isLoading = false;
    this.cd.markForCheck();
  }
}
